import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FourBenefitsComponent} from "./four-benefits.component";
import {TitleModule} from "../title/title.module";

@NgModule({
  imports: [
    CommonModule,
    TitleModule
  ],
  declarations: [FourBenefitsComponent],
  exports: [FourBenefitsComponent]
})
export class FourBenefitsModule { }
